import axios from 'axios';
import authHeader from "@/service/auth-header";

class DigitalFormService {

    async getDigitalForm(companyId, uniqueId) {
        return await axios.get(`/api/digitalform/${companyId}/specific/${uniqueId}`, {headers: authHeader()})
    }

    async getDigitalForms(companyId) {
        return await axios.get(`/api/digitalform/${companyId}`, {headers: authHeader()})
    }

    async getDigitalFormLink(id) {
        return await axios.get(`/api/digitalform/link/${id}`, {headers: authHeader()})
    }

    async searchCompanyDigitalForms(companyId, name) {
        return await axios.get(`/api/digitalform/search/${companyId}/${name}`, {headers: authHeader()})
    }

    async createDigitalForm(companyId, data) {
        return await axios.post(`/api/digitalform/${companyId}`, data, {headers: authHeader()});
    }

    async updateDigitalForm(formId, data) {
        return await axios.put(`/api/digitalform/${formId}`, data, {headers: authHeader()});
    }

    async deleteDigitalForm(formId) {
        return await axios.delete(`/api/digitalform/${formId}`, {headers: authHeader()})
    }

    async createDigitalFormComponent(formId, data) {
        return await axios.post(`/api/digitalform/${formId}/component`, data, {headers: authHeader()});
    }

    async updateDigitalFormComponent(id, data) {
        return await axios.put(`/api/digitalform/component/${id}`, data, {headers: authHeader()});
    }

    async deleteDigitalFormComponent(id) {
        return await axios.delete(`/api/digitalform/component/${id}`, {headers: authHeader()})
    }

    async createDigitalFormResponse(formId, data) {
        return await axios.post(`/api/digitalform/${formId}/response`, data, {headers: authHeader()});
    }

    async getUniqueResponses(formId) {
        return await axios.get(`/api/digitalform/responses/${formId}`, {headers: authHeader()})
    }

    async deleteDigitalFormResponse(uniqueId) {
        return await axios.delete(`/api/digitalform/responses/${uniqueId}`, {headers: authHeader()})
    }

}

export default new DigitalFormService();
